const getProductByHandleQuery = /* GraphQL */ `
  query getProductByHandle($handle: String!) {
    productByHandle(handle: $handle) {
      id
      handle
      availableForSale
      title
      productType
      descriptionHtml
      labIdentifier: metafield(namespace: "custom", key: "lab_identifier") {
        value
        key
      }
      isExpress: metafield(namespace: "custom", key: "is_express") {
        value
        key
      }
      featuredImage: images(first: 1) {
        edges {
          node {
            originalSrc
            altText
            width
            height
          }
        }
      }
      variants(first: 250) {
        pageInfo {
          hasNextPage
          hasPreviousPage
        }
        edges {
          node {
            id
            title
            sku
            availableForSale
            requiresShipping
            selectedOptions {
              name
              value
            }
            priceV2 {
              amount
              currencyCode
            }
            compareAtPriceV2 {
              amount
              currencyCode
            }
            image {
              altText
              originalSrc
            }
            variantSlug: metafield(namespace: "custom", key: "variant_slug") {
              value
              key
            }
          }
        }
      }
    }
  }
`

export default getProductByHandleQuery
